import React, { useEffect, useState } from "react"
import { Heading } from "frontend/components/text"
import { Button } from "frontend/components/interaction"
import { Modal } from "frontend/components/layout"
import t, { Translation } from "frontend/utils/translations"
import styles from "./IncentivizedUploadSuccess.module.css"
import { getIncentivizedUploadData } from "frontend/utils/upload"
import { handleDownload } from "frontend/utils/download"
import { getUserLogin } from "./util/copy"

const IncentivizedUploadSuccess = () => {
  const [isModalOpen, setIsModalOpen] = useState(true)

  const { title, thumbnail, download_path: downloadPath, id } = getIncentivizedUploadData()

  const onDownload = async (e) => {
    e.preventDefault()
    await handleDownload({ id }, downloadPath, "incentivized_upload_flow")
  }

  useEffect(() => {
    handleDownload({ id }, downloadPath, "incentivized_upload_flow")
  }, [])

  return (
    <div className={styles.container} id="incentivized-success">
      <img className={styles.thumbnail} src={thumbnail} />
      <hr />
      <Heading size={4}>{t("upload.published.incentivized.unlocked", { title })}</Heading>
      <Button
        className={styles.button}
        onClick={onDownload}
        label={t("upload.published.incentivized.download_button")}
        icon="download"
      />
      <p className={styles.cta}>
        <Translation
          string="upload.published.incentivized.share_prompt"
          options={{
            login: getUserLogin(),
          }}
        />
      </p>
      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} className={styles.modal}>
        <img src={thumbnail} />
        <hr />
        <Heading size={3} className={styles.modalHeading}>
          {t("upload.published.incentivized.heading")}
        </Heading>
        <p className={styles.modalCta} onClick={onDownload}>
          <Translation string="upload.published.incentivized.download" />
        </p>
      </Modal>
    </div>
  )
}

export default IncentivizedUploadSuccess
